import React, {Component} from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import {
  path,
  mergeDeepLeft,
  clone,
} from 'ramda';
import Breadcrumbs from '../../common/Breadcrumbs';
import Input from '../../common/Input';
import DynamicFormList from '../../common/DynamicFormList';
import ReactSelectWrapper from '../../common/ReactSelectWrapper';
import '../../css/forms/default-forms.css';
import {
  basic as fields,
  contacts,
  details,
  sales_persons
} from './fields';
import style from './style';
import {processFields} from '../../utils/prePost';
import {validateFields} from '../../utils/validate';
import {updateProject, getProjectWithContacts, getSalesPersonsList} from '../../api/projects';
import {linkDataToFields} from '../../utils/fields';
import hasAccess from "../../helpers/permissionChecker";

const removeFieldMap = {
  details: {id_name: 'detail_id', state_key: 'remove_project_detail_ids'},
  contacts: {id_name: 'user_id', state_key: 'remove_project_users_ids'},
  sales_persons: {id_name: 'sales_persons_id', state_key: 'project_sales_persons_ids'},
};

export class CustomerAdd extends Component {

  constructor(props) {
    super(props);
    this.state = {
      submit: false,
      errors: [],
      fields: fields,
      fieldsSync: false,
      remove_project_detail_ids: [],
      remove_project_users_ids: [],
      project_sales_persons_ids: [],
      salesPersonsList: [],
      salesFullData: [],
      sales_remove_ids: [],
      sales_add_ids: []
    };
    this.submit = this.submit.bind(this);
    this.cancel = this.cancel.bind(this);
    this.changeFormValue = this.changeFormValue.bind(this);
    this.fetchDataRouteById = this.fetchDataRouteById.bind(this);
  }

  fetchDataRouteById() {
    const id = path(['match', 'params', 'id'], this.props);

    this.props.getDataById(id);
  }

  componentDidMount() {
    this.props.getSalesPersonsList();
    this.fetchDataRouteById();
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (!nextProps.projects.salesPersonsList.length) {
      return false
    }
    return true
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.projects.salesPersonsList.length ) {
      this.setState({salesPersonsList: this.parseSalesPersonList(path(['projects', 'salesPersonsList'], this.props))});
    }
    if (prevProps.projects.currentContacts
      && this.props.projects.currentContacts
      && this.props.projects.salesPersonsList.length
      && (JSON.stringify(prevProps.projects.currentContacts) !== JSON.stringify(this.props.projects.currentContacts))) {
      this.setState({fieldsSync: false, salesPersonsList: this.parseSalesPersonList(path(['projects', 'salesPersonsList'], this.props))});
    }
    if (this.state.fieldsSync === false) {
      const currentCustomer = path(['projects', 'currentProject'], this.props);
      const currentContacts = path(['projects', 'currentContacts'], this.props);
      const currentSalesPerson = path(['projects', 'currentSalesPerson'], this.props);
      if (currentCustomer && currentContacts) {
        // Add contacts to customer object
        currentCustomer.contacts = currentContacts;
        currentCustomer.sales_persons = currentSalesPerson;
        const linkFields = {
          contacts: [],
          details: [],
          sales_persons: [],
          username: this.state.fields.username,
          terms: this.state.fields.terms,
          taxing: this.state.fields.taxing,
        };
        const extraFields = {contacts: {...contacts}, details: {...details}, sales_persons: {...sales_persons}};

        const fields = linkDataToFields(
          currentCustomer,
          linkFields,
          null,
          extraFields
        );

        fields.contacts.map(contact => {
          contact.billing.value = contact.types.value.includes('billing');
          contact.shipping.value = contact.types.value.includes('shipping');

          return contact;
        });
        this.setState({
          fields: fields,
          fieldsSync: true,
        });
      }
    }
  }

  submit(e) {
    e.preventDefault();
    const {remove_project_detail_ids, remove_project_users_ids, project_sales_persons_ids} = this.state;
    let result = validateFields(this.state.fields);
    if (result.check === false) {
      this.setState({
        fields: result.fields,
      });
    } else {
      const processedData = processFields(this.state.fields);
      processedData.remove_project_detail_ids = remove_project_detail_ids.map((value) => (value.id));
      processedData.remove_project_users_ids = remove_project_users_ids.map((value) => (value.id));
      const remove = [];
      const add = [];
      project_sales_persons_ids.forEach((item) => {
        if(item.relation_id){
          remove.push(item.relation_id.value);
        }
      });
      if(processedData.sales_persons) {
        processedData.sales_persons.forEach((item) => {
          if(item.relation_id === ""){
            add.push(item.user_id);
          }
        });
      }
      delete processedData.sales_persons;
      this.setState({
        sales_remove_ids: remove,
        sales_add_ids: add
      }, () => {
        const id = path(['match', 'params', 'id'], this.props);
        this.props.saveForm(id, JSON.stringify(processedData), remove, add)
      });
    }
    return false;
  }

  cancel() {
    this.props.redirectToCustomers();
  }

  changeFormValue(field, newObject) {
    let stateClone = clone(this.state);
    if (removeFieldMap[field]) {
      const current = removeFieldMap[field];
      const newValues = getValuesByPath(newObject, [current.id_name, 'value']);
      const oldValues = getValuesByPath(this.state.fields[field], [current.id_name, 'value']);

      const deleted = getDeletedValuesOfArray(oldValues, newValues);
      stateClone[current.state_key] = stateClone[current.state_key].concat(deleted);
    }
    if (typeof field === 'object') {
      // FIX: add support of multiple levels
      stateClone.fields[field[0]][field[2]] = newObject;
    } else {
      stateClone.fields[field] = newObject;
    }
    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  parseSalesPersonList(arr) {
    const arrCustomers = [];
    const sales = {};
    if (arr) {
      for (let i = 0; i < arr.length; i++) {
        sales[arr[i].id] = arr[i];
        arrCustomers.push({
          text: arr[i].firstname + ' ' + arr[i].lastname,
          user_id: arr[i].id,
          value: arr[i].id,

        });
      }
    }
    this.setState({salesFullData: sales});
    return arrCustomers;
  }

  parseList(arr) {
    if (arr) {
      return arr.map((item) => ({
          value: item,
          label: item,
        })
      );
    }

    return [];
  }

  render() {
    const hasAccessForEdit = hasAccess({
      'permAreaKey': 'customer',
      'permTypeKey': 'edit',
      'idForCheckingAuthor': path(['projects', 'currentProject', 'user_id'], this.props)
    });
    const disableFieldForEdit = !hasAccessForEdit;
    return (
      <div>
        <Breadcrumbs list={[
          {url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard'},
          {url: '/pages/customers', icon: 'account_circle', name: 'Customers'},
          {icon: 'edit', name: 'Customers Edit'},
        ]}/>
        <div className="card" style={style.rounded}>
          <div className="card-header">
            <b>Edit Customer</b>
          </div>
          <div className="card-block">
            <div className="col" style={{paddingBottom: '40px'}}>
              <button className={'btn btn-danger btn-outline pull-right ml-3'} onClick={this.cancel}>
                <i className="fa fa-remove"></i>
                <span className="pl-1">Cancel</span>
              </button>
              {hasAccessForEdit &&
              <button className={'btn btn-success btn-outline pull-right'} onClick={this.submit}>
                <i className="fa fa-check"></i>
                <span className="pl-1">Save</span>
              </button>
              }
            </div>

            <form onSubmit={this.submit}>
              <div className="col-12">
                <Input
                  disabled={disableFieldForEdit}
                  field={this.state.fields['username']}
                  onChange={this.changeFormValue}
                />

                <ReactSelectWrapper
                  options={this.parseList(path(['terms', 'options'], this.state.fields))}
                  field={this.state.fields['terms']}
                  onChange={this.changeFormValue}
                />

                <ReactSelectWrapper
                  options={this.parseList(path(['taxing', 'options'], this.state.fields))}
                  field={this.state.fields['taxing']}
                  onChange={this.changeFormValue}
                />

                <DynamicFormList
                  disabled={disableFieldForEdit}
                  list={this.state.fields['contacts']}
                  onChange={this.changeFormValue}
                  fields={contacts}
                  idsForRemote={this.state.remove_project_users_ids}
                />

                <DynamicFormList
                  disabled={disableFieldForEdit}
                  list={this.state.fields['details']}
                  onChange={this.changeFormValue}
                  fields={details}
                  idsForRemote={this.state.remove_project_detail_ids}
                />

                <DynamicFormList
                  options={this.state.salesPersonsList}
                  disabled={disableFieldForEdit}
                  list={this.state.fields['sales_persons']}
                  onChange={this.changeFormValue}
                  fields={sales_persons}
                  idsForRemote={this.state.project_sales_persons_ids}
                />

              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}

const getValuesByPath = (stack, pathArray) => {
  return stack.map(item => path(pathArray, item));
};

const getDeletedValuesOfArray = (oldArray, newArray) => {
  return oldArray.filter(item => newArray.indexOf(item) < 0);
};

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    redirectToCustomers: () => {
      dispatch(push('/pages/customers'));
    },
    getDataById: (id) => {
      getProjectWithContacts(id)(dispatch);
    },
    saveForm: (id, data, remove, add) => {
      updateProject(id, data, remove, add)(dispatch);
    },
    getSalesPersonsList: () => {
      getSalesPersonsList()(dispatch);
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerAdd);



// WEBPACK FOOTER //
// ./src/containers/EditCustomer/index.js